export default class EasyRead {
	constructor() {
		this.cookieName = 'dsa_easyread';
		this.toggle = $('.easyread-toggle');
		this.active = false;
		this.init();
	}

	init() {
		// only proceed if content available
		if( this.toggle.hasClass('disabled') ) {
			return;
		}

		// check hash
		if( document.location.hash.indexOf('easyread') > 0) {
			this.setCookie(1);
		}

		// set visibility state
		this.active = this.getCookie();

		this.setVisibility();

		// handle toggle
		this.toggle.click( (event) => {
			$(event.currentTarget).toggleClass('active');
			this.active = !this.active;
			this.setCookie( this.active );
			this.setVisibility();
			document.location.hash = this.active ? 'easyread' : '';
		});

	}

	setVisibility() {
		if( this.active ) {
			$('body').addClass('easyread');
			this.toggle.addClass('active').removeClass('inactive').text('Turn off Easy Read content');
		} else {
			$('body').removeClass('easyread');
			this.toggle.addClass('inactive').removeClass('active').text('Turn on Easy Read content');
		}
	}

	getCookie() {
		var cookies = document.cookie.split(';');
		var value = false;

		for(var i = 0; i < cookies.length; i++) {
			var v = cookies[i].split('=');
			if( v[0].trim() == this.cookieName ) {
				value = v[1];
				break;
			}
		}

		return !!parseInt(value);
	}

	setCookie(value) {
		// store the token in a cookie
		var now = new Date();
		var expireTime = now.getTime() + 365*24*60*60*1000;
		now.setTime(expireTime);
		document.cookie = `${this.cookieName}=${value};Path=/;Expires=${now.toGMTString()}`;
	}
}